import config from "@Config/index";
import axios from "axios";

// eslint-disable-next-line import/prefer-default-export
export const createVirtualTourRequest = async (params: any, options = {}) => {
  try {
    const { data } = await axios.post(
      `${config.API_URL}/api/v0/leads/virtual_tour_request`,
      {
        lead: params.lead,
        ...options,
      },
      {
        withCredentials: true,
      },
    );
    return { ...data };
  } catch (error: any) {
    return { error };
  }
};
